import { compose, withState, withHandlers, withPropsOnChange, withProps } from 'recompose';
import OrdersItem from 'pages/Orders/Item';
import { NotificationManager } from 'react-notifications';
import {  withResolver } from 'components/common';
import { ApiClient } from 'services';
import _ from 'lodash';
import { isFunction, map } from 'lodash';

export const enhance = compose(
  withState('jobStatuses', 'setJobStatuses', null),
  withResolver(
    {
      jobStatuses: () => client => client.get('job_statuses_by_type?filter=installer-assigned-modify-no-incomplete'),
    },
    {
      onResolved: ({ setJobStatuses, item }) => ({ jobStatuses }) => {
        var statuses = _.get(_.find(jobStatuses, (obj) => obj.type.value == item.job_type), 'statuses');
        setJobStatuses(statuses);
      },
    }
  ),
  withProps(() => ({
    isInstaller: true 
  })),
  withPropsOnChange([], ({ client }) => ({
    canAssign: false,
    client: client || ApiClient(),
    displayCountry: true,
  })),
  withState('comments', 'setComments', ''),
  withState('reason', 'setReason', 1),
  withState('acceptPending', 'setAcceptPending', false),
  withHandlers({
    onAccept: ({
      setAcceptPending,
      client,
      item,
      comments,
      onAccepted,
      onInstallerReplied,
    }) => () => {
      setAcceptPending(true);
      client
        .post(`/installer-orders/${item.id}/accept?order_status=new`, {
          comments,
        })
        .tap(() => {
          NotificationManager.success('Order accepted');
          return isFunction(onInstallerReplied) && onInstallerReplied();
        })
        .finally(() => setAcceptPending(false));
    },
    onReject: ({
      setAcceptPending,
      client,
      item,
      comments,
      reason,
      refreshData,
      onInstallerReplied,
    }) => () => {
      setAcceptPending(true);
      client
        .post(`/installer-orders/${item.id}/reject?order_status=new`, {
          rejection: parseInt(reason),
          comments,
        })
        .tap(() => {
          NotificationManager.success('Order rejected');
          return isFunction(onInstallerReplied) && onInstallerReplied();
        })
        .finally(() => setAcceptPending(false));
    },
  })
);

export default enhance(OrdersItem);



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/OrdersItem.js